import { Action, createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export enum AuthActionTypes {
  Login_Request = '[Auth] Login Request',
  Login_Success = '[Auth] Login Success',
  Login_Failure = '[Auth] Login Failure',
  Logout = '[Auth] Logout'
}

export const LoginRequest = createAction(
  // for login request
  AuthActionTypes.Login_Request,
  props<{ username: any; password: any; dbName: any }>()
);

export const LoginSuccess = createAction(
  // for login Success
  AuthActionTypes.Login_Success,
  props<{ userAuth: any }>()
);

export const LoginFailure = createAction(
  // for login failure
  AuthActionTypes.Login_Failure,
  props<{ errorState: HttpErrorResponse }>()
);

export const Logout = createAction(
  // for logout
  AuthActionTypes.Logout
);
